import { useMemo } from 'react';
import { formatPhoneNumber } from '../common/formatting/phoneFormat';
import { Box, CopyToClipboard } from '@cloudscape-design/components';

export type PhoneNumberProps = {
  phoneNumber?: string | null;
}

export function PhoneNumber(props: PhoneNumberProps) {
  const { phoneNumber } = props;

  const formattedPhoneNumber = useMemo(() => {
    return `${phoneNumber ? formatPhoneNumber(phoneNumber) : '-'}`;
  }, [phoneNumber]);

  return phoneNumber ? (
    <CopyToClipboard
      copyButtonAriaLabel="Copy phone number"
      copyErrorText="Phone number failed to copy"
      copySuccessText="Phone number copied"
      textToCopy={formattedPhoneNumber}
      variant="inline"
    />
  ) : (
    <Box variant="span">{formattedPhoneNumber}</Box>
  );
}
